import axios from 'axios';
import toastr from 'mini-toastr';

toastr.init();

export async function open_iDocs(docOrUrl, loadingStateCallback) {
  let url = '';
  if (typeof docOrUrl === 'string') {
    url = docOrUrl;
  } else if (docOrUrl && typeof docOrUrl === 'object') {
    url = docOrUrl.iDocsURL || '';
  }

  const base = process.env.VUE_APP_IDOCS_URL_BASE || 'https://idocs.metrotvnews.tv/api/docfin/';
  if (!url || !url.includes(base)) {
    toastr.error('URL of iDocs Document is invalid ', 'ERROR MESSAGE', 10000);
    return;
  }

  // Ensure url is clean (strip credentials if any exist in the url)
  if (url.includes('@')) {
    url = url.replace(/^(https?:\/\/)[^@]+@/, '$1');
  }

  if (loadingStateCallback) loadingStateCallback(true);

  try {
    const username = process.env.VUE_APP_IDOCS_USER || '';
    const password = process.env.VUE_APP_IDOCS_PWD || '';

    const token = btoa(`${username}:${password}`);

    const response = await axios.get(url, {
      headers: {
        Authorization: `Basic ${token}`
      },
      responseType: 'blob'
    });

    const contentType = response.headers['content-type'] || 'application/pdf';
    const blob = new Blob([response.data], { type: contentType });
    const objectUrl = window.URL.createObjectURL(blob);

    const newWindow = window.open(objectUrl, '_blank');
    if (!newWindow) {
      toastr.error('Pop-up blocked! Please allow pop-ups for this site.', 'ERROR MESSAGE', 10000);
    }

    // Revoke the object URL after 30 seconds to allow the browser to load it
    setTimeout(() => {
      window.URL.revokeObjectURL(objectUrl);
    }, 30000);

  } catch (error) {
    console.error('Error opening iDocs document:', error);
    toastr.error('Failed to retrieve iDocs Document', 'ERROR MESSAGE', 10000);
  } finally {
    if (loadingStateCallback) loadingStateCallback(false);
  }
}

export async function show_iDocs(params, loadingStateCallback) {
  let url = '';
  let category;
  if (typeof params === 'string') {
    category = params;
  } else if (params && typeof params === 'object') {
    category = params.cat;
  }
  if (category) {
    url = `https://idocs.metrotvnews.tv/api/docfin/browse?cat=${category}&view=thumb`;
  } else {
    url = `https://idocs.metrotvnews.tv/api/docfin/browse?view=thumb`;
  }


  if (loadingStateCallback) loadingStateCallback(true);

  try {
    const username = process.env.VUE_APP_IDOCS_USER || '';
    const password = process.env.VUE_APP_IDOCS_PWD || '';

    const token = btoa(`${username}:${password}`);

    const response = await axios.get(url, {
      headers: {
        Authorization: `Basic ${token}`
      },
      responseType: 'blob'
    });

    const contentType = response.headers['content-type'] || 'application/pdf';
    const blob = new Blob([response.data], { type: contentType });
    const objectUrl = window.URL.createObjectURL(blob);

    const newWindow = window.open(objectUrl, '_blank');
    if (!newWindow) {
      toastr.error('Pop-up blocked! Please allow pop-ups for this site.', 'ERROR MESSAGE', 10000);
    }

    // Revoke the object URL after 30 seconds to allow the browser to load it
    setTimeout(() => {
      window.URL.revokeObjectURL(objectUrl);
    }, 30000);

  } catch (error) {
    console.error('Error opening iDocs document:', error);
    toastr.error('Failed to retrieve iDocs Document', 'ERROR MESSAGE', 10000);
  } finally {
    if (loadingStateCallback) loadingStateCallback(false);
  }
}
